import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import style from './required-indicator.less';

export const RequiredIndicator = React.memo(({ className = '' }) => {
  return (
    <div className={classnames(className, style['required-indicator'])}>
      <div className={style['required-indicator-content']}>
        <span>*</span>
      </div>
    </div>
  );
});

RequiredIndicator.propTypes = {
  className: PropTypes.string,
};
